export const sideBarData1 = {
  title: 'About',
  href: '/about',
  subItems: [
    { id: 1, title: 'Management', href: '/management' },
    { id: 2, title: 'Careers', href: '/jobs' },
    { id: 3, title: 'Hera Flight Race Team', href: '/hera-flight-race-team' },
  ],
};

export const sideBarData2 = {
  title: 'Services',
  href: '/services',
  subItems: [
    { id: 1, title: 'Aircraft management', href: '/aircraft-management' },
    { id: 2, title: 'Aircraft sales', href: '/aircraft-sales' },
  ],
};
export const sideBarData3 = {
  title: 'Charter Flights',
  href: '/charter',
  subItems: [{ id: 1, title: 'Empty Leg Flights', href: '/empty-leg-flights' }],
};

export const sideBarData4 = {
  title: 'Jet Card',
  href: '/hera-10-hour-s-jet-program',
  subItems: [
    {
      id: 1,
      title: 'Jet Card 10 Hours',
      href: '/hera-10-hour-s-jet-program',
    },
    {
      id: 2,
      title: 'Jet Card 25 Hours',
      href: '/hera-jet-card-membership',
    },
  ],
};
